/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  FetchBillingResponseLicensingDirectorBilling,
  FetchBillingResponseLicensingDirectorBillingFromJSON,
  FetchBillingResponseLicensingDirectorBillingToJSON,
} from './'

/**
 * (Deprecated). Contains licensing billing and payment information for coordinator directors.
 * @export
 * @interface FetchBillingResponseLicensingDirector
 */
export interface FetchBillingResponseLicensingDirector {
  /**
   *
   * @type FetchBillingResponseLicensingDirectorBilling
   * @memberof FetchBillingResponseLicensingDirector
   */
  billing?: FetchBillingResponseLicensingDirectorBilling
}

export function FetchBillingResponseLicensingDirectorFromJSON(
  json: any
): FetchBillingResponseLicensingDirector {
  return FetchBillingResponseLicensingDirectorFromJSONTyped(json, false)
}

export function FetchBillingResponseLicensingDirectorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchBillingResponseLicensingDirector {
  if (json === undefined || json === null) {
    return json
  }
  return {
    billing: !exists(json, 'billing')
      ? undefined
      : FetchBillingResponseLicensingDirectorBillingFromJSON(json['billing']),
  }
}

export function FetchBillingResponseLicensingDirectorToJSON(
  value?: FetchBillingResponseLicensingDirector | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    billing: FetchBillingResponseLicensingDirectorBillingToJSON(value.billing),
  }
}
